import request from "@/utils/request";
import qs from "qs";

/**
 * 查询商品列表
 * @param params
 * @returns {*}
 */
export function getGoodsList(params) {
  return request({
    url: "/goods/getList",
    method: "get",
    params
  });
}

/**
 * 查询商品列表【导出】
 * @param params
 * @returns {*}
 */
export function exportGoodsList(params) {
  return request({
    url: "/goods/exportList",
    method: "get",
    responseType: "blob", // 重要：设置responseType为'blob'以处理二进制数据
    params
  });
}

/**
 * 查询商品预览详情
 * @param params
 * @returns {*}
 */
export function getGoodsPreviewDetail(params) {
  return request({
    url: "/goods/getGoodsPreviewDetail",
    method: "get",
    params
  });
}

/**
 * 查询商品编辑详情
 * @param params
 * @returns {*}
 */
export function getGoodsEditDetail(params) {
  return request({
    url: "/goods/getGoodsEditDetail",
    method: "get",
    params
  });
}

/**
 * 新增-编辑商品
 * @param params
 * @returns {*}
 */
export function editGoods(params) {
  console.log("新增-编辑商品", params, qs.stringify(params));
  return request.post("/goods/editGoods", qs.stringify(params));
}

/**
 * 上架-下架商品
 * @param params
 * @returns {*}
 */
export function upDownGoods(params) {
  return request.post("/goods/upDownGoods", qs.stringify(params));
}

/**
 * 删除-恢复商品
 * @param params
 * @returns {*}
 */
export function deleteGoods(params) {
  return request.post("/goods/deleteGoods", qs.stringify(params));
}

/**
 * 审核商品
 * @param params
 * @returns {*}
 */
export function checkGoods(params) {
  return request.post("/goods/checkGoods", qs.stringify(params));
}

/**
 * 查询可赠送的赠品
 * @param params
 * @returns {*}
 */
export function getGiftConfigs(params) {
  return request({
    url: "/goods/getGiftConfigs",
    method: "get",
    params
  });
}

//删除规格的货品
export function deleteGoodsSpecs(params) {
  return request.post("/goods/deleteGoodsSpecs", qs.stringify(params));
}

// 同步货品

export function syncGoodsSpecs() {
  return request({
    url: "/schl/synchronizeGoods",
    method: "get"
  });
}

// 导出导入模版
export function exportGoodsTemplate() {
  return request({
    url: "/goods/getImportGoodsTemplate",
    method: "get"
  });
}

// 导入商品
export function importGoods(params) {
  const formData = new FormData();
  formData.append("file", params.file);
  return request({
    url: "/goods/importGoods",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

// 查询TBC兑CNY价格
export function getTbcCnyPrice() {
  return request({
    url: "/goods/getTbcCnyPrice",
    method: "get"
  });
}

// 修改TBC兑CNY价格
export function updateTbcCnyPrice(params) {
  return request.post("/goods/updateTbcCnyPrice", qs.stringify(params));
}

export function getGoodsTagList(params) {
  return request({
    url: "/goodsTag/getTagList",
    method: "get",
    params
  });
}

export function getEnabledGoodsTagList(params) {
  return request({
    url: "/goodsTag/getTagList",
    method: "get",
    params
  });
}

export function editGoodsTag(params) {
  return request.post("/goodsTag/edit", qs.stringify(params));
}

export function deleteGoodsTag(params) {
  return request.post("/goodsTag/disable", qs.stringify(params));
}

export function getGoodsSkuStocks(params) {
  return request({
    url: "/goods/getSkuStocks",
    method: "get",
    params
  });
}

// 商品编辑页可选择的人工标签（自动联动标签与系统触发标签会被过滤）
export function getSelectableGoodsTagList() {
  return request({
    url: "/goodsTag/getSelectableTagList",
    method: "get"
  });
}

export function getGoodsTagLinkageList() {
  return request({
    url: "/goodsTag/getLinkageList",
    method: "get"
  });
}

export function editGoodsTagLinkage(params) {
  return request.post("/goodsTag/editLinkage", qs.stringify(params));
}

export function deleteGoodsTagLinkage(params) {
  return request.post("/goodsTag/deleteLinkage", qs.stringify(params));
}

export function syncGoodsTagLinkage() {
  return request.post("/goodsTag/syncLinkage");
}

/**
 * 复制已上架商品，复制件默认进入待审核状态
 * @param {{id: number}} params
 */
export function copyGoods(params) {
  return request.post("/goods/copyGoods", qs.stringify(params));
}

export function getGoodsMetaList(params) {
  return request({
    url: "/goodsMeta/getList",
    method: "get",
    params
  });
}

export function editGoodsMeta(params) {
  return request.post("/goodsMeta/edit", qs.stringify(params));
}

export function deleteGoodsMeta(params) {
  return request.post("/goodsMeta/delete", qs.stringify(params));
}

export function getGoodsMetaValueList(params) {
  return request({
    url: "/goodsMeta/getValueList",
    method: "get",
    params
  });
}

export function editGoodsMetaValue(params) {
  return request.post("/goodsMeta/editValue", qs.stringify(params));
}

export function deleteGoodsMetaValue(params) {
  return request.post("/goodsMeta/deleteValue", qs.stringify(params));
}

export function getGoodsMetaOptions(params) {
  return request({
    url: "/goodsMeta/getOptions",
    method: "get",
    params
  });
}

export function getGoodsSkuList(params) {
  return request({
    url: "/goodsSku/getList",
    method: "get",
    params
  });
}

export function queryJstSuppliers(params) {
  return request({
    url: "/erp/jst/supplier/query",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: params || {}
  });
}

export function queryJstDistributionSuppliers(params) {
  return request({
    url: "/erp/jst/distribution/supplier/query",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: params || {}
  });
}
